import config from '../services/config';
export var referenceMaterial = function referenceMaterial(centralApi, getToken) {
  return {
    getContent: function getContent(id) {
      return "".concat(config.api.url, "/reference-material/").concat(id, "/content?token=").concat(getToken().accessToken);
    },
    getEpubContent: function getEpubContent(id) {
      return "".concat(config.api.url, "/reference-material/").concat(id, "/content.epub?token=").concat(getToken().accessToken);
    }
  };
};